export default [
    {
        path: '/educationalGroups',
        name: 'educationalGroups',
        component: () => import ('./pages/EducationalGroupRegister')
    },
]